module.exports = __webpack_public_path__ + "img/new-lady-sweeps.1657d3c9.png";